import React from "react";
import classNames from "classnames";
import getConfig from "next/config";
import Image from "@components/ContentEditorView/Image";

const {
  publicRuntimeConfig: {
    settings: { websiteName },
  },
} = getConfig();
const isBricoStore = websiteName === "bricostore";

const Content = (props) => {
  const createMarkup = (content) => ({ __html: content });

  return (
    <div className={props.classNames}>
      {props.html && <div dangerouslySetInnerHTML={createMarkup(props.html)} />}
    </div>
  );
};

const TextImage = (props) => {
  const containerClass = classNames("flow-root", {
    "u-border-b-dotted": props.borderBottom,
    "u-border-t-dotted": props.borderTop,
    "u-space-mb-10 u-space-mt-10": props.verticalMargin,
    "u-space-pt-10 u-space-pb-10": props.verticalPadding,
    "u-space-p-10": props.fullPadding,
    "Content-children-inherit": props.color,
    "Content-flex": props.imageAlign === "left" || props.imageAlign === "right",
  });

  const containerStyles = {
    backgroundColor:
      props.bgColor && props.bgColor.length > 0 ? props.bgColor : null,
    color: props.color && props.color.length > 0 ? props.color : null,
  };

  const imageClass = classNames({
    "osm-u-float-left md-u-space-pr-10 lg-u-space-pr-10 Content-flex-first":
      props.imageAlign === "left",
    "osm-u-float-right md-u-space-pl-10 lg-u-space-pl-10 Content-flex-second":
      props.imageAlign === "right",
    "md-u-size-6of12 lg-u-size-6of12":
      (props.imageAlign === "left" || props.imageAlign === "right") &&
      props.imageSize === "half",
    "md-u-size-4of12 lg-u-size-4of12":
      (props.imageAlign === "left" || props.imageAlign === "right") &&
      props.imageSize === "1third",
    "md-u-size-8of12 lg-u-size-8of12":
      (props.imageAlign === "left" || props.imageAlign === "right") &&
      props.imageSize === "2thirds",
  });

  const textClass = classNames({
    "bd-hero-claim": isBricoStore,
    [`osm-u-text-align-${props.align}`]: props.align !== "left",
    "osm-u-float-right md-u-space-pl-10 lg-u-space-pl-10 Content-flex-second":
      props.imageAlign === "left",
    "osm-u-float-left md-u-space-pr-10 lg-u-space-pr-10 Content-flex-first":
      props.imageAlign === "right",
    "md-u-size-6of12 lg-u-size-6of12":
      (props.imageAlign === "left" || props.imageAlign === "right") &&
      props.imageSize === "half",
    "md-u-size-8of12 lg-u-size-8of12":
      (props.imageAlign === "left" || props.imageAlign === "right") &&
      props.imageSize === "1third",
    "md-u-size-4of12 lg-u-size-4of12":
      (props.imageAlign === "left" || props.imageAlign === "right") &&
      props.imageSize === "2thirds",
  });

  return (
    <div className={containerClass} style={containerStyles}>
      {props.imageAlign !== "topCenter" && (
        <Content classNames={textClass} html={props.html} />
      )}

      <Image {...props} classNames={imageClass} />

      {props.imageAlign === "topCenter" && (
        <Content classNames={textClass} html={props.html} />
      )}
    </div>
  );
};

export default TextImage;
